// Auto-generated normalizer for table: CuestionarioRespuestaOpcionMultiple_Opciones
export function cuestionarioRespuestaOpcionMultipleOpcionesNormalize(row) {
  return {
    idOpcion: row.idOpcion ?? row.IdOpcion ?? row['IdOpcion'] ?? 0,
    idRespuestaOpcionMultiple: row.idRespuestaOpcionMultiple ?? row.IdRespuestaOpcionMultiple ?? row['IdRespuestaOpcionMultiple'] ?? 0,
    texto: row.texto ?? row.Texto ?? row['Texto'] ?? '',
    esCorrecta: row.esCorrecta ?? row.EsCorrecta ?? row['EsCorrecta'] ?? false,
    orden: row.orden ?? row.Orden ?? row['Orden'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
